// MissingPolygonsWarning.tsx
import React, { useState } from "react";
import { Button, Modal, Table, Text, Title, Code, Group } from "@mantine/core";
import { useAppSelector } from "../../app/hooks";
import { selectIfcSpacesWithMissingPolygon } from "./twoDFloorplanSelectors";
import { useClipboard } from "@mantine/hooks";

export const MissingPolygonsWarning: React.FC = () => {
  const missingSpaces = useAppSelector(selectIfcSpacesWithMissingPolygon);
  const [opened, setOpened] = useState(false);
  const clipboard = useClipboard({ timeout: 500 });

  const count = missingSpaces.length;

  if (count === 0) return null;

  // Generera kodsnutten
  const globalIds = missingSpaces.map((space) => `'${space.globalId}'`).join(",\n         ");
  const generatedCode = `    const result = await parseFileInTest({
      fileName: \`03001-J1-00-00-A-200-IF-001.ifc\`,
      saveOutput: true,
       filteredElementGlobalIds: [
         ${globalIds}
       ],
    });`;

  return (
    <>
      <Button variant="outline" color="red" onClick={() => setOpened(true)}>
        Varning: {count} spaces saknar polygon
      </Button>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={<Title order={3}>Spaces utan polygon</Title>}
        size="lg"
      >
        <Text mb="md">Följande {count} IfcSpace-items saknar polygon-data:</Text>
        <Table striped highlightOnHover withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>LongName</Table.Th>
              <Table.Th>Name</Table.Th>
              <Table.Th>GlobalId</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {missingSpaces.map((space) => (
              <Table.Tr key={space.globalId}>
                <Table.Td>{space.longName || "N/A"}</Table.Td>
                <Table.Td>{space.name || "N/A"}</Table.Td>
                <Table.Td>{space.globalId}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>

        <Text mt="lg" mb="xs">
          Genererad kod för test:
        </Text>
        <Code block>{generatedCode}</Code>
        <Group mt="md" justify="flex-end">
          <Button onClick={() => clipboard.copy(generatedCode)}>
            {clipboard.copied ? "Kopiert!" : "Kopier kode"}
          </Button>
        </Group>
      </Modal>
    </>
  );
};
